module.exports = __webpack_public_path__ + "media/images/footer_logo-44138392b5efea39806f0be9d5b6cff5.png";